module.exports = __webpack_public_path__ + "img/set-spend-limit.4822f216.svg";